import { Observable } from 'rxjs';

export enum WebsocketMessageType {
  PREFERENCE_RETRIEVAL = 'PREFERENCE_RETRIEVAL',
  ACCOUNTS_RETRIEVAL = 'ACCOUNTS_RETRIEVAL',
  ORDER_SUBSCRIPTION = 'ORDER_SUBSCRIPTION',
  ORDER_STATUS = 'ORDER_STATUS',
  QUOTE_STREAMING = 'QUOTE_STREAMING',
  QUOTE_INFO = 'QUOTE_INFO',
  VIDEO = 'VIDEO',
  VIDEO_RECOMMENDATION = 'VIDEO_RECOMMENDATION',
  LEARN_BOOKMARK = 'LEARN_BOOKMARK',
  TOAST_MESSAGE = 'TOAST_MESSAGE'
}

export type WebsocketData = Record<string, unknown>;

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type WebsocketMessage<T> = {
  type: WebsocketMessageType;
  version?: string;
  sessionId?: string;
  systemTimestamp?: string;
  locationId?: string;
  createdTimestamp?: Date;
  correlationId?: string;
  payload: T;
}

export interface WebsocketConfiguration {
  readonly url: string;
  sessionTimeoutCallback: (() => Observable<number>);
}

export enum WebsocketErrorStatusCodes {
  NORMAL_CLOSURE = 1000,
  GOING_AWAY = 1001,
  SERVER_ERROR = 1011,
  CUSTOM_ERROR = 4000
}
